import { DashboardContainerRoot } from '@/features/home/components/container';
import { DashboardHeader } from '@/features/home/components/header';
import { PlayerPathwayCard } from '@/features/home/components/player-pathway-card';
import { WelcomeBanner } from '@/features/home/components/welcome-banner';
import { memo } from 'react';

export const HomeView = Object.assign(DashboardContainerRoot, {
  Header: memo(DashboardHeader),
  WelcomeBanner: memo(WelcomeBanner),
  PlayerPathwayCard: memo(PlayerPathwayCard),
});
